module.exports = __webpack_public_path__ + "05_medium_gold.f76b819c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/05_medium_gold.png
// module id = Ugz6
// module chunks = 0